import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import {
  HTTPValidationError,
  IPersonnel,
  IPersonnelAdd,
  IPersonnelUpdate,
  ISite,
  ISuccessfulResponse
} from 'src/types/SiteStudyPersonal';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const personnelApi = createApi({
  baseQuery,
  reducerPath: 'personnelApi',
  endpoints: builder => ({
    getAllPersonnel: builder.query<IPersonnel[], Pick<ISite, 'site_id' | 'study_id'>>({
      query: ({ site_id, study_id }) => ({
        url: formatString(
          endPoints.Personnel.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )
      }),
      extraOptions: { maxRetries: 3 }
    }),
    addPersonnal: builder.mutation<IPersonnel, IPersonnelAdd>({
      query: ({ site_id, study_id, data }) => ({
        url: formatString(
          endPoints.Site.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        ),
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updatePersonnal: builder.mutation<ISuccessfulResponse | HTTPValidationError, IPersonnelUpdate>({
      query: ({ site_id, study_id, data }) => ({
        url: formatString(
          endPoints.Site.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        ),
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useGetAllPersonnelQuery, useUpdatePersonnalMutation } = personnelApi;
